<!-- Choose a new password — reached from the reset mail via TokenState. -->
<main class="onb onb--sheet">

  <header class="onb__head">
    <p class="belturo-eyebrow onb__head-eyebrow"><%= _lcs( 'Konto' ) %></p>
    <h1 class="onb__head-title"><em><%= _lcs( 'Neues Passwort vergeben' ) %></em></h1>
    <p class="onb__head-sub"><%= _lcs( 'Wähle ein neues Passwort für dein Konto.' ) %></p>
  </header>

  <form class="onb__scroll onb__form" id="reset-form" autocomplete="on" novalidate>
    <!-- Lets password managers file the new password under the right account. -->
    <input type="email" name="username" autocomplete="username" value="<%= email %>" hidden />

    <div class="field">
      <label class="field__label" for="reset-new"><%= _lcs( 'Neues Passwort' ) %></label>
      <div class="field__control">
        <span class="field__icon"><i class="icon icon--lock"></i></span>
        <input class="field__input" id="reset-new" name="newPassword" type="password"
               autocomplete="new-password" placeholder="<%= _lcs( 'Mindestens 8 Zeichen' ) %>" required />
        <button class="field__toggle" type="button" data-toggle="reset-new" aria-label="<%= _lcs( 'Passwort anzeigen' ) %>" aria-pressed="false">
          <i class="icon icon--eye"></i>
        </button>
      </div>
    </div>

    <div class="field">
      <label class="field__label" for="reset-repeat"><%= _lcs( 'Neues Passwort wiederholen' ) %></label>
      <div class="field__control">
        <span class="field__icon"><i class="icon icon--lock"></i></span>
        <input class="field__input" id="reset-repeat" name="repeatPassword" type="password"
               autocomplete="new-password" required />
        <button class="field__toggle" type="button" data-toggle="reset-repeat" aria-label="<%= _lcs( 'Passwort anzeigen' ) %>" aria-pressed="false">
          <i class="icon icon--eye"></i>
        </button>
      </div>
    </div>

    <p class="auth__error" data-id="reset-error" role="alert" hidden></p>
  </form>

  <footer class="onb__foot onb__foot--bordered onb__foot--form">
    <button class="btn btn--primary btn--lg btn--block" type="submit" form="reset-form" data-id="save">
      <%= _lcs( 'Passwort speichern' ) %>
    </button>
    <p class="auth__switch onb__switch">
      <a class="auth__link auth__link--strong" href="#" data-id="to-login"><%= _lcs( 'Zurück zur Anmeldung' ) %></a>
    </p>
  </footer>

</main>
